module.exports = __webpack_public_path__ + "static/media/ic_grid.07ab5ff8.svg";